import request from "../libs/request";

import { BuildingId } from "../types/building";

const incommodityUrl = "center/incommodity";

export type DefaultIncommodityCategoryListRequest = BuildingId & {
  limit?: number;
};

export type IncommodityCategoryListRequest = BuildingId & {
  searchWord: string;
};

export type IncommodityCategory = {
  serviceName: string;
  sortOrder: number;
  serviceItemType: string | null;
  serviceItemTypeName: string | null;
  vocPlacePlaceholder: string;
  vocDetailPlaceholder: string;
  vocRequestTypeArray: string;
  isRequiredVocPlace: boolean;
  isRequiredVocDetail: boolean;
  vocTypeCode: string;
  equipmentTypeCode: string;
  serviceTemplateId: number;
};

export const getDefaultIncommodityCategoryList = (
  params: DefaultIncommodityCategoryListRequest
) =>
  request.get<IncommodityCategory[]>(
    incommodityUrl + "/user/category/list/default",
    {
      params,
    }
  );

export type IncommodityCategoryGroup = { [key: string]: IncommodityCategory[] };

export const getIncommodityCategoryList = (
  params: IncommodityCategoryListRequest
) =>
  request.get<IncommodityCategoryGroup>(
    incommodityUrl + "/user/category/list",
    {
      params,
    }
  );

export type IncommodityCreateRequest = BuildingId & {
  buildingFloorId: string;
  atgBuildingId: string;
  atgBuildingVocId: string;
  atgVocTypeCode: string;
  atgBuildingFloorId: string;
  atgVocEquipmentTypeCode: string;
  buildingSpaceId: string;
  description: string;
  deadLine?: string;
  location?: string;
  requestDetail?: string;
};

export type IncommodityCreateResponse = {
  result: string;
  centerIncommodityId: number;
};

export const insertIncommodity = (params: FormData) =>
  request.post<IncommodityCreateResponse>(incommodityUrl + "/user", params, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
